import { render, staticRenderFns } from "./transferDetail.vue?vue&type=template&id=1a1edaf4&scoped=true"
import script from "./transferDetail.vue?vue&type=script&lang=ts"
export * from "./transferDetail.vue?vue&type=script&lang=ts"
import style0 from "./transferDetail.vue?vue&type=style&index=0&id=1a1edaf4&prod&lang=scss&scoped=true"
import style1 from "./transferDetail.vue?vue&type=style&index=1&id=1a1edaf4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a1edaf4",
  null
  
)

export default component.exports